<script>
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;

	pageNumber.update((p) => pageIndex);
	document.title = pageTitle;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">{projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<h2 class="text-center">FILE UPLOAD</h2>

			<p>
				Hello {$model.FirstName}
				{$model.Surname},
			</p>
			<p>
				To add files to your registration for the {projectSettings.classActionName} please click "UPLOAD FILES".
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons showPrevious="false" {nextPage} nextPageLabel="UPLOAD FILES"></NavigationButtons>
		</div>
	</div>
	<div class="row justify-content-md-center" style="margin-top: 12px;">
		<div class="col-md-8 col-sm-12">
			<p>
				If you require support completing this form, please contact Shine Lawyers on <ClassActionPhoneNumber
				></ClassActionPhoneNumber>
				or via email to <ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2,
	h3 {
		font-size: 1.1em;
		margin-bottom: 16px;
	}

	h2 {
		font-weight: 700;
	}
</style>
